export { default as antenna1 } from './antenna_1.jpg';
export { default as antenna2 } from './antenna_2.jpg';
export { default as antenna3 } from './antenna_3.jpeg';
export { default as diySkyminer1 } from './diy_skyminer_1.jpg';
export { default as diySkyminer2 } from './diy_skyminer_2.jpg';
export { default as diySkyminer3 } from './diy_skyminer_3.jpg';
export { default as diySkyminer4 } from './diy_skyminer_4.jpg';
export { default as diySkyminer5 } from './diy_skyminer_5.jpg';
export { default as diySkyminer6 } from './diy_skyminer_6.jpg';
export { default as diySkyminer7 } from './diy_skyminer_7.jpg';
export { default as diySkyminer8 } from './diy_skyminer_8.jpg';
export { default as diySkyminer9 } from './diy_skyminer_9.jpg';
export { default as diySkyminer10 } from './diy_skyminer_10.jpg';
export { default as diySkyminer11 } from './diy_skyminer_11.jpg';
export { default as diySkyminer12 } from './diy_skyminer_12.jpg';
export { default as diySkyminer13 } from './diy_skyminer_13.jpg';
export { default as diySkyminer14 } from './diy_skyminer_14.jpg';
export { default as diySkyminer15 } from './diy_skyminer_15.jpg';
export { default as diySkyminer16 } from './diy_skyminer_16.jpg';
export { default as diySkyminer17 } from './diy_skyminer_17.jpg';
export { default as diySkyminer18 } from './diy_skyminer_18.jpg';
export { default as diySkyminer19 } from './diy_skyminer_19.jpg';
export { default as diySkyminer20 } from './diy_skyminer_20.jpg';
export { default as diySkyminer21 } from './diy_skyminer_21.jpg';
export { default as diySkyminer22 } from './diy_skyminer_22.jpg';
export { default as diySkyminer23 } from './diy_skyminer_23.jpg';
export { default as diySkyminer24 } from './diy_skyminer_24.jpg';
export { default as diySkyminer25 } from './diy_skyminer_25.jpg';
export { default as diySkyminer26 } from './diy_skyminer_26.jpg';
export { default as diySkyminer27 } from './diy_skyminer_27.jpg';
export { default as diySkyminer28 } from './diy_skyminer_28.jpg';
export { default as diySkyminer29 } from './diy_skyminer_29.jpg';
export { default as diySkyminer30 } from './diy_skyminer_30.jpg';
export { default as diySkyminer31 } from './diy_skyminer_31.jpg';
export { default as diySkyminer32 } from './diy_skyminer_32.jpg';
export { default as diySkyminer33 } from './diy_skyminer_33.jpg';
export { default as diySkyminer34 } from './diy_skyminer_34.jpg';
export { default as diySkyminer35 } from './diy_skyminer_35.jpg';
export { default as diySkyminer36 } from './diy_skyminer_36.jpg';
export { default as diySkyminer37 } from './diy_skyminer_37.jpg';
export { default as diySkyminer38 } from './diy_skyminer_38.jpg';
export { default as diySkyminer39 } from './diy_skyminer_39.jpg';
export { default as diySkyminer40 } from './diy_skyminer_40.jpg';
export { default as diySkyminer41 } from './diy_skyminer_41.jpg';
export { default as diySkyminer42 } from './diy_skyminer_42.jpg';
export { default as diySkyminer43 } from './diy_skyminer_43.jpg';
export { default as diySkyminer44 } from './diy_skyminer_44.jpg';
export { default as diySkyminer45 } from './diy_skyminer_45.jpg';
export { default as diySkyminer46 } from './diy_skyminer_46.jpg';
export { default as diySkyminer47 } from './diy_skyminer_47.jpg';
export { default as diySkyminer48 } from './diy_skyminer_48.jpg';
export { default as diySkyminer49 } from './diy_skyminer_49.jpg';
export { default as diySkyminer50 } from './diy_skyminer_50.jpg';
export { default as diySkyminer51 } from './diy_skyminer_51.jpg';
export { default as diySkyminer52 } from './diy_skyminer_52.jpg';
export { default as wallet1 } from './hardware_wallet_1.jpg';
export { default as wallet2 } from './hardware_wallet_2.jpg';
export { default as wallet3 } from './hardware_wallet_3.jpg';
export { default as wallet4 } from './hardware_wallet_4.jpg';
export { default as wallet5 } from './hardware_wallet_5.jpg';
export { default as wallet6 } from './hardware_wallet_6.jpg';
export { default as wallet7 } from './hardware_wallet_7.jpg';
export { default as wallet8 } from './skywallet_1.jpeg';
export { default as wallet9 } from './skywallet_2.jpeg';
export { default as wallet10 } from './skywallet_3.jpeg';
export { default as wallet11 } from './skywallet_4.jpeg';
export { default as wallet12 } from './skywallet_5.jpeg';
export { default as wallet13 } from './skywallet_6.jpeg';
export { default as wallet14 } from './skywallet_7.jpeg';
export { default as wallet15 } from './skywallet_8.jpg';
export { default as wallet16 } from './skywallet_9.jpg';
export { default as wallet17 } from './skywallet_10.jpg';
export { default as wallet18 } from './skywallet_11.jpg';
export { default as wallet19 } from './skywallet_12.jpg';
export { default as skyminer1 } from './skyminer_1.png';
export { default as skyminer2 } from './skyminer_2.png';
export { default as skyminer3 } from './skyminer_3.png';
export { default as skyminer4 } from './skyminer_4.png';
export { default as skyminer5 } from './skyminer_5.png';
export { default as skyminer6 } from './skyminer_6.png';
export { default as skyminer7 } from './skyminer_7.png';
export { default as skyminer8 } from './skyminer_8.png';
export { default as biyagi01 } from './biquad/1.png';
export { default as biyagi02 } from './biquad/2.png';
export { default as biyagi03 } from './biquad/3.png';
export { default as biyagi04 } from './biquad/4.png';
export { default as biyagi05 } from './biquad/5.png';
export { default as biyagi06 } from './biquad/6.png';
export { default as biyagi07 } from './biquad/7.png';
export { default as biyagi08 } from './biquad/8.png';
export { default as biyagi09 } from './biquad/9.png';
export { default as biyagi10 } from './biquad/10.png';
export { default as biyagi11 } from './biquad/11.png';
export { default as biyagi12 } from './biquad/12.png';
export { default as biyagi13 } from './biquad/13.png';
export { default as biyagi14 } from './biquad/14.png';
export { default as biyagi15 } from './biquad/15.png';
export { default as biyagi16 } from './biquad/16.png';



// WEBPACK FOOTER //
// ./src/components/GalleryPage/images/index.js